import { useQuery } from "@tanstack/react-query";
import api from "../../../../../utils/api";
import { useErrorSuccess } from "../../../../../hooks/useErrorSuccess";

export type TLider = {
  cargo: string;
  celula: number;
  cpf: string;
  grupo: null;
  id: number;
  ministerio: null;
  ministerio_celula: number;
  nome_cargo: string;
  nome_celula: string;
  nome_grupo: null;
  nome_ministerio: null;
  nome_ministerio_celula: string;
  nome_sede: null;
  nome_sede_celula: string;
  nome_usuario: string;
  sede: null;
  sede_celula: number;
  telefone: string;
  usuario: number;
};

const ServicesLideres = () => {
  const { setErrorSuccess } = useErrorSuccess();

  const { data: coordenadores = [] } = useQuery({
    queryFn: () => api.get<TLider[]>("ministerio/cargo/usuario/membro/cargo/7"),
    queryKey: ["coordenadores-lista"],
    select: (data) => data?.data,
  });

  const handleIncluirLiderInCelula = async (lider: TLider, pg: number) => {
    if (!lider) {
      setErrorSuccess({
        mensagem: "Nãoooooooo! não tem ninguém selecionado",
        status: "warning",
      });
    }

    try {
      const listEvent = await api
        .get<
          {
            evento: number;
            nome_evento: string;
            sede: number;
            nome_sede: string;
            ministerio: number;
            nome_ministerio: string;
            diasemana: string;
            celula: number;
            nomecelula: string;
          }[]
        >("view/evento/inscricaopg")
        .then((res) => {
          return res?.data?.find(evento => evento.celula == pg)
        });


      if(!listEvent) {
        setErrorSuccess({
          mensagem: "Nenhum evento encontrado",
          status: "warning",
        });
        return;
      }

      const req = await api.post(`usuario/gerar/ingresso/${listEvent?.evento}`, {
        cargo: lider?.cargo,
        celula: pg,
        usuario: lider?.usuario,
        motivo: "inserção interna da web" 
      });

      const res = await req?.data;

      if (res) {
        setErrorSuccess({
          mensagem: "Incluído!",
          status: "success",
        });
        return;
      }
      
      setErrorSuccess({
        //@ts-ignore
        mensagem: req?.response?.data?.mensagem || 'Error',
        status: "error",
      });
    } catch (error: any) {
      setErrorSuccess({
        mensagem: JSON.stringify(
          error?.response.data?.mensagem || error?.response.data
        ),
        status: "error",
      });
    }
  };

  return {
    coordenadores,
    handleIncluirLiderInCelula,
  };
};

export default ServicesLideres;
